var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 6.99935C8.61051 6.99935 9.91634 5.69351 9.91634 4.08268C9.91634 2.47185 8.61051 1.16602 6.99967 1.16602C5.38884 1.16602 4.08301 2.47185 4.08301 4.08268C4.08301 5.69351 5.38884 6.99935 6.99967 6.99935Z",
    fill: "#1E2224"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99977 8.45898C4.07727 8.45898 1.69727 10.419 1.69727 12.834C1.69727 12.9973 1.8256 13.1257 1.98893 13.1257H12.0106C12.1739 13.1257 12.3023 12.9973 12.3023 12.834C12.3023 10.419 9.92227 8.45898 6.99977 8.45898Z",
    fill: "#1E2224"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e468134c57aae25db816063c9fb2b920.svg";
export { ForwardRef as ReactComponent };